<h1 class="page-title">Address Change Requests</h1>
<section class="widget">
    <div class="widget-body">
        <div class="mt">
            <table-dynamic id="address-change-requests-datatable" class="table table-striped table-hover"
                           [headers]="tableHeaders" [currentPage]="currentPage" [totalCount]="totalCount"
                           (headerClick)="sortRequests($event)" (pageChanged)="setPage($event)"
                           (limitChange)="setLimit($event)">
                <tr *ngFor="let request of requestsList?.items">
                    <td><a [routerLink]="['../company', request?.companyId]" target="_blank"><strong>{{request?.companyName}}</strong></a></td>
                    <td>{{formatAddress(request?.oldAddress1, request?.oldAddress2, request?.oldCity, request?.oldState, request?.oldZipCode)}}</td>
                    <td>{{formatAddress(request?.address1, request?.address2, request?.city, request?.state, request?.zipCode)}}</td>
                    <td><a [routerLink]="['/app/user', request?.requestedByUserId]" target="_blank" *ngIf="request?.requestedByUserId">{{request?.requestedByName}}</a><span *ngIf="!request?.requestedByUserId">{{request?.requestedByName}}</span></td>
                    <td>{{request?.enteredDate | moment: 'L'}}</td>
                    <td>
                        <button class="btn btn-sm btn-success me-1" (click)="approveRequest(request)">Approve</button>
                        <button class="btn btn-sm btn-danger" (click)="denyRequest(request)">Deny</button>
                    </td>
                </tr>
            </table-dynamic>
        </div>
    </div>
</section>
